import { Root } from '@radix-ui/react-tabs'

export const Tabs = Root
